import { useMutation } from "@tanstack/react-query";
import SoftSelect from "components/SoftSelect";
import React, { useState } from "react";
import { cancelB2COrder, cancelShipment, updateOrderTimeline } from "../../../../config/Services";
import StyledButton from "../../product/all-products/components/custom/StyledButton";
import { useSnackbar } from "../../product/hooks/SnackbarProvider";
import usePrint from "../../product/hooks/usePrint";
import "./BoardItemActions.css";
import { Typography } from "@mui/material";
import { manualOrderRefresh } from "../../../../utils/odsArchitecture/orderPollingService";
const BoardItemActions = ({
  item,
  orderQuery,
  openModal,
  handleClose,
  orderId,
  validationModal,
}) => {
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails"));
  const retailType = localStorage.getItem("retailType");
  const { startPrint, isPrinting } = usePrint();
  const showSnackbar = useSnackbar();
  const [selectedReason, setSelectedReason] = useState({});
  const cancelOrderMutation = useMutation({
    mutationFn: async (payload) => {
      const res = await cancelB2COrder(payload);
      if (res?.data?.code === "ECONNRESET") {
        throw new Error(res?.data?.message);
      }
      if (res?.data?.data?.es) {
        throw new Error(res?.data?.data?.message);
      }
      return res;
    },
    onSuccess: (res) => {
      showSnackbar("Order cancelled", "success");
      manualOrderRefresh();
      handleClose();
    },
    onError: (error) => {
      showSnackbar(error?.response?.data?.message || error?.message, "error");
    },
  });
  const cancelShipmentMutation = useMutation({
    mutationFn: (payload) => cancelShipment(payload),
    onSuccess: (res) => {
      if (res?.data?.data?.es) {
        showSnackbar(res?.data?.data?.message, "error");
        return;
      }
      showSnackbar(res?.data?.data?.data?.message || "Shipment cancelled successfully", "success");
      manualOrderRefresh();
      handleClose();
    },
    onError: (error) => {
      showSnackbar(error?.response?.data?.message || error?.message, "error");
    },
  });

  const cancelShipmentMutationFoRestaurant = useMutation({
    mutationFn: (payload) => updateOrderTimeline(payload),
    onSuccess: (res) => {
      if (res?.data?.data?.es) {
        showSnackbar(res?.data?.data?.message, "error");
        return;
      }
      showSnackbar(res?.data?.data?.data?.message || "Shipment cancelled successfully", "success");
      manualOrderRefresh();
      handleClose();
    },
    onError: (error) => {
      showSnackbar(error?.response?.data?.message || error?.message, "error");
    },
  });

  const acceptOrderMutation = useMutation({
    mutationFn: async (payload) => {
      const res = await updateOrderTimeline(payload);
      if (res?.data?.code === "ECONNRESET") throw new Error(res?.data?.message);
      if (res?.data?.data?.es) throw new Error(res?.data?.data?.message);
      return res;
    },
    onSuccess: (res) => {
      const responseData = res?.data?.data;
      if (responseData?.showPopup) {
        const readyAtIST = new Date(`${responseData?.readyAt}:00Z`).toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });
        const [datePart, timePart] = readyAtIST.split(", ");
        showSnackbar(
          `Order cannot be moved before: ${datePart?.replace(
            /\//g,
            "-"
          )}, ${timePart.toUpperCase()}`,
          "warning"
        );
        return;
      }
      showSnackbar("Order status updated successfully", "success");
      startPrint({
        orderId: orderId,
        printType: "invoice",
        orderSource: "b2c",
        onPrintComplete: handleClose,
      });
      manualOrderRefresh();
    },
    onError: (error) => {
      showSnackbar(error?.response?.data?.message || error?.message, "error");
    },
  });

  const handleAcceptOrder = () => {
    const userName = localStorage.getItem("user_name");
    acceptOrderMutation.mutate({
      orderId,
      orderStatus: "PACKAGED",
      updatedBy: userName,
    });
  };

  const handleCancelShipment = () => {
    if (item?.subOrderType === "DELIVERY") {
      const restaurantPayload = {
        orderId: orderId,
        orderStatus: "CANCELLED",
        updatedBy: retailUserDetails?.uidx,
      };
      cancelShipmentMutationFoRestaurant.mutate(restaurantPayload);
      return;
    }
    if (!item?.shipmentId) {
      showSnackbar("Cannot cancel shipment without shipment Id", "error");
      return;
    }
    const payload = {
      shipmentId: item?.shipmentId,
      orderId: orderId,
      userId: retailUserDetails?.uidx,
      reason: selectedReason?.label,
    };
    cancelShipmentMutation.mutate(payload);
  };
  const handleCancelOrder = () => {
    const payload = {
      userId: item?.loggedInUserId,
      loggedInUserId: item?.loggedInUserId,
      reason: selectedReason?.label,
      orderId: orderId,
      licenseId: item?.licenseId,
    };
    cancelOrderMutation.mutate(payload);
  };
  const renderOrderUpdate = () =>
    retailType !== "RESTAURANT" && (
      <div className="board-item-order-update-container">
        <Typography fontWeight="bold">Actions</Typography>
        <div className="board-item-details-select-text">Order updates</div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
          }}
        >
          <SoftSelect
            options={[
              { value: "not_responding", label: "Customer not responding" },
              { value: "address_not_found", label: "Address not found" },
              { value: "house_locked", label: "House locked" },
              { value: "entry_denied", label: "Entry denied" },
              { value: "other", label: "Other" },
            ]}
            onChange={(value) => setSelectedReason(value)}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            placeholder={"Select reason for order failure"}
            classNamePrefix="soft-select"
            styles={{
              menu: (base) => ({
                ...base,
                minWidth: "200px",
                maxWidth: "320px",
              }),
            }}
          />
          {item?.fulfilmentStatus !== "CREATED" && (
            <StyledButton
              style={{ width: "100%", marginLeft: "auto", height: "2.2rem" }}
              variant="secondary"
              color="red"
              onClick={handleCancelShipment}
              disabled={!selectedReason?.label}
              loading={cancelShipmentMutation?.isLoading}
            >
              Cancel Shipment
            </StyledButton>
          )}
        </div>
      </div>
    );
  switch (item?.fulfilmentStatus) {
    case "CREATED":
      return (
        retailType !== "RESTAURANT" && (
          <div className="board-item-details-created-actions">
            <div className="board-item-created-scrollable-content">
              <div className="board-item-details-buttons-box">
                <StyledButton
                  onClick={() => startPrint({ orderId: orderId, printType: "picklist" })}
                  className="vendor-add-btn board-item-btns-1"
                  loading={isPrinting}
                >
                  Print Pick List
                </StyledButton>
                {!validationModal ? (
                  <StyledButton
                    onClick={item?.salesChannel === "WHATSAPP_ORDER" ? undefined : openModal}
                    className="board-item-btns-2"
                    disabled={item?.salesChannel === "WHATSAPP_ORDER"}
                  >
                    Validate
                  </StyledButton>
                ) : null}
              </div>
              <div className="board-item-details-created-top-box">
                <div>{renderOrderUpdate()}</div>
              </div>
            </div>
            <section className="board-item-accept-reject-section">
              <StyledButton
                style={{ flex: 1, borderRadius: "20px" }}
                variant="secondary"
                color="red"
                onClick={handleCancelOrder}
                disabled={!selectedReason?.label}
                loading={cancelOrderMutation?.isPending}
              >
                Reject Order
              </StyledButton>
              <StyledButton
                style={{ flex: 1, borderRadius: "20px" }}
                onClick={handleAcceptOrder}
                loading={acceptOrderMutation?.isPending}
              >
                Accept Order
              </StyledButton>
            </section>
          </div>
        )
      );
    case "PACKAGED":
      return (
        <div className="board-item-details-created-actions">
          <div className="board-item-details-created-top-box">
            <div>{renderOrderUpdate()}</div>
          </div>
          {retailType !== "RESTAURANT" && (
            <div className="board-item-details-buttons-box">
              <StyledButton
                onClick={() =>
                  startPrint({ orderId: orderId, printType: "invoice", orderSource: "b2c" })
                }
                className="vendor-add-btn"
                loading={isPrinting}
                sx={{ width: "100%" }}
              >
                Print Invoice
              </StyledButton>
            </div>
          )}
        </div>
      );
    case "IN_TRANSIT":
      return (
        <div className="board-item-details-created-actions">
          <div className="board-item-details-created-top-box">
            <div>{renderOrderUpdate()}</div>
          </div>
        </div>
      );
    case "DELIVERED":
      return (
        <div className="board-item-details-created-actions">
          <div className="board-item-details-created-top-box">
            {/* <div>{renderOrderUpdate()}</div> */}
          </div>
        </div>
      );
    default:
      return null;
  }
};
export default BoardItemActions;
